import { ServiceCode } from '@/shared/types';
import { InformerProps } from '@/shared/ui';

import { ColorConfig } from '@/contexts/AntdConfigProvider/theme';

export interface ExternalInformerConfig extends Omit<InformerProps, 'header' | 'text'> {
  predefinedInformerType?: PredefinedInformerType;
  predefinedDisplayCondition?: InformersCondition;
  formValueConditions?: Record<string, any>;
  linkKey?: string;
  header?: {
    text?: string;
    color?: ColorConfig;
  };
  text?: {
    text?: string;
    color?: ColorConfig;
  };
}

export type ExternalInformersConfig = Record<string, ExternalInformerConfig[]>;

export type ExternalServiceInformers = Partial<Record<ServiceCode, ExternalInformersConfig>>;

export enum PredefinedInformerType {
  CLUE = 'clue',
  CONTACT_CENTER = 'contactCenter',
  VALIDITY_PERIOD_VIOLATION = 'validityPeriodViolation',
  PLACE_OF_RESIDENCE = 'placeOfResidence',
  TECHNICAL_CONDITION_DETAILS = 'technicalConditionDetails',
  TECHNICAL_CONDITION_DOCUMENT_DATA = 'technicalConditionDocumentData',
  PAYMENT_DETAILS = 'paymentDetails',
  HAS_ACTIVE_REQUEST = 'hasActiveRequest',
  CRIMINAL_RECORD_EXTRACT_VIDEO_ELECTRONIC = 'criminalRecordExtractVideoElectronic',
  CRIMINAL_RECORD_EXTRACT_VIDEO_PAPER = 'criminalRecordExtractVideoPaper',
  QRCODE_DIIA = 'qrCode',
  QRCODE_DIIA_NEXT = 'qrCodeNext',
  PAYMENT_OFFLINE = 'paymentOffline',
  PAYMENT_ONLINE = 'paymentOnline',
  PERSON_STATUS = 'personStatus',
  LEARNING_DOCUMENT = 'learningDocument',
  PAPER_EXTRACT_DISABLED = 'paperExtractDisabled',
  ELECTRONIC_EXTRACT_DISABLED = 'electronicExtractDisabled',
}

export enum InformersCondition {
  IS_NOT_LOGGED_IN = 'isNotLoggedIn',
}
